var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header",class:{ 'over-baseline': _vm.scrollY >= 600 || _vm.path !== '/' }},[_c('div',{staticClass:"top"},[_c('div',{staticClass:"logo"},[_c('div',{staticClass:"to-top",on:{"click":_vm.top}},[_c('img',{class:{
            'over-baseline2':
              (_vm.scrollY >= 600 && _vm.documentheight - _vm.scrollY > 1100) ||
              (_vm.path !== '/' && _vm.documentheight - _vm.scrollY > 1100),
          },attrs:{"src":`${_vm.rootUrl}/img/takumi-hirano_logo02.png`,"alt":"匠味平野ロゴ"}})])]),_c('div',{staticClass:"hamburger"},[_c('UiDrawer')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }